export const SharedStakeStatus = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  INACTIVE: "INACTIVE",
} as const;

export type SharedStakeStatusType =
  (typeof SharedStakeStatus)[keyof typeof SharedStakeStatus];
